import type { FaireProductEntity } from "../../entity_types/product";

export const p_mwz7tamkqu: FaireProductEntity = {
  token: "p_mwz7tamkqu",
  type: "product",
  name: "7.2oz. No. 6 Cactus + Aloe Candle",
  brandToken: "b_y6mta332qy",
  brandName: "Choice Blooms",
  imageUrl:
    "https://cdn.faire.com/fastly/99aff3b26ce967493253256ffc08fcba9352081a598baedff8684f4279ae0624.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20b12c058405d23922024f1a56f3e4aaadbdd8f2a46286db98a0a014f498b3ec.jpeg",
    "https://cdn.faire.com/fastly/1c599ef86fc6942dd0cc145c3cab9ec035c54ec11df90c9d8191b885cc3d3356.jpeg",
    "https://cdn.faire.com/fastly/842cc0be4595f21783e5c412c6c433879f0d5fb68484bdbfaacbdfa3cbd850da.jpeg",
    "https://cdn.faire.com/fastly/65cda2ce6686a84371223150773f583fa89e2b8e78e75fa6da31e907fb661d72.jpeg",
    "https://cdn.faire.com/fastly/5f9d05c6df1e7d179caa010a6484ae9fb44200bad18c14b59fd03982fd04dbb1.jpeg",
  ],
  priceDollars: 16,
  description:
    "This 7.2 oz size will be discontinued - available while supplies last.\nThis glass is different - less candle, more glass, heavier + thicker from the other sizes - please consider this when mixing the sizes in your assortment.\n\nNo. 6 Cactus + Aloe made with hemp coconut blend wax and burns with a hemp wick all in a groovy translucent iridescent glass vessel.\n\n7.2 oz. in an 8 oz vessel. 40-50 burn time hours.\n\n**The Smell**\nNo. 6 Cactus + Aloe - floral, leafy green, bright, refreshing\n• Top: Aloe, Agave\n• Heart: Chrysanthemum, Green Floral, Green Leaves\n• Base: Patchouli\n\n**The Glass**\nSoda lime glass with our signature groovy, crinkle-inspired shape.\nDesigned to be reused after the final burn as a vase, catchall, or everyday object.\nSlight variations in shape and finish may occur.\n\n**The Wax**\nPoured with a coconut soy wax blend selected for a smooth finish and fragrance performance. As a softer wax blend, slight texture changes or softening may occur during warmer weather or transit. These variations are cosmetic and do not affect candle performance.\n\n**The Wick**\nMade with a hemp wick.\nFree from lead, zinc, and metal cores.\n\n**Fragrance + Ingredients**\nMade with fragrance and essential oil blends.\nFormulated without added phthalates or parabens.\nCruelty-free.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T19:41:50.730Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
